import React, {Fragment, useEffect, useState, useRef} from 'react'
import {Button, Card, Form, Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useFormik} from 'formik'
import {LoadingComponent} from 'recupero-comunes'
import Acciones from './acciones'
import {validationSchemas} from '../../../../common/validation-Schemas-tipo-gasto'
import {limpiarRefAction, obtenerGrillaHistorialGastos, postActualizarTipoGastoJudicial} from '../../../../store/actions/modal-gastos-honorarios-action'
import GastosHonorarios from './gastosHonorarios'
import { formatoMonto, resetFormatoMonto, resetFormatoMontoSinPunto } from '../../../../common/Formatos'
import { esArchivoGrande, subirArchivoGrandeS3 } from '../../../../common/uploadArchivoGranTamano'
import { serviceObtieneParametro } from '../../../../api/api-parametros'
// import Historial from './historial'

const GastosHonorariosModal = ({showGastos, handleCloseGastos}) => {
    const [loading, setLoading]=useState(false)
    const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
    const { llaves } = data_gestion_defensa;

    const data_gastos_honorarios = useSelector((state) => state.modalGastosHonorariosReducer)
    const {comboTipoGasto} = data_gastos_honorarios

    const [porcConvOldData, setPorcConvOldData] = useState('')    
    const [isGastoHonorario, setIsGastoHonorario] = useState(false)
    const [modedadata, setMonedaData] = useState('')
    const [miMontoNoFormato, setMiMontoNOFormato] = useState('')
    const [showToastAnular, setShowToastAnular] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [isLimpiar, setIsLimpiar] = useState(false);
    const [listaGrilla, setListaGrilla] = useState(null)
    const dispatch = useDispatch()
    const handleCloseToastAnular = () => setShowToastAnular(false)
    const handleShowToastAnular = () => setShowToastAnular(true)
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true)

    const [limites, setLimites] = useState({ liviano: 8 * 1000000, pesado: 20 * 1000000 });
    const [showConfirmGrande, setShowConfirmGrande] = useState(false);
    const [pendingFile, setPendingFile] = useState(null);
    const archivoSubidoRef = useRef({ file: null, s3Bucket: null, s3Key: null });

    const cargarLimites = async () => {
        const [liviano, pesado] = await Promise.all([serviceObtieneParametro(52), serviceObtieneParametro(53)]);
        setLimites({ liviano, pesado });
    };

    useEffect(() => {
        if (showGastos) cargarLimites();
    }, [showGastos])

    const handleFileChange = (file) => {
        if (!file) return;

        if (esArchivoGrande(file, limites.liviano)) {
            setPendingFile(file);
            setShowConfirmGrande(true);
        } else {
            formik.setFieldValue("file", file);
        }
    }

    const handleCancelArchivoGrande = () => {
        setPendingFile(null);
        dispatch(limpiarRefAction(true));
        setShowConfirmGrande(false);
    }

    const handleConfirmArchivoGrande = () => {
        formik.setFieldValue("file", pendingFile);
        setShowConfirmGrande(false);
    }

    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "tipoGasto": "",
            "cobertura": "",
            "moneda": "",
            "monto": "",
            "fechaOcurrencia": "",
            "comentario": ".",
            "secuencia": "",
            "idUsuario": ""
        },
        validationSchema: validationSchemas(isGastoHonorario, limites.pesado),
        onSubmit: async (formData) => {
            const dataForm = {
                ...formData
            }
            dataForm['idCaso'] = llaves && llaves['idCaso']
            dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado']
            dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso']
            dataForm['idUsuario'] = llaves && llaves['idUsuario']
            /* dataForm['monto'] = miMontoNoFormato */
            dataForm['monto'] = Number(validateMontoMoneda(formData.monto, 'reset_format'));
            const secuencia = 0
            dataForm['secuencia'] = secuencia

            let cob = comboTipoGasto && comboTipoGasto.comboTipoGasto.find(c => c.id === parseInt(dataForm['tipoGasto'])).agrupacion
            dataForm['cobertura'] = cob

            setLoading(true)

            try {
                let fileData = null;

                if (formData.file) {
                    if (esArchivoGrande(formData.file, limites.liviano)) {
                        let archivoRef;
                        if (archivoSubidoRef.current.file === formData.file) {
                            archivoRef = archivoSubidoRef.current;
                        } else {
                            archivoRef = await subirArchivoGrandeS3(formData.file);
                            archivoSubidoRef.current = { file: formData.file, ...archivoRef };
                        }
                        fileData = { filename: formData.file.name, mimetype: formData.file.type, s3Bucket: archivoRef.s3Bucket, s3Key: archivoRef.s3Key };
                    } else {
                        const base64data = await getBase64(formData.file);
                        fileData = { filename: formData.file.name, mimetype: formData.file.type, base64data: base64data.split(',')[1] };
                    }
                }

                let data = { ...dataForm };
                if (fileData) data.file = fileData;

                const resultado = await dispatch(postActualizarTipoGastoJudicial(data));
                const respuesta = resultado?.payload?.respuestaTipoGastos;

                handleShowToast()

                if (!respuesta || respuesta.code !== 1) {
                    //Se conservan los datos y el adjunto para que el usuario pueda reintentar.
                    setLoading(false)
                    return;
                }

                await historial();
                dispatch(limpiarRefAction(true))
                setIsLimpiar(true)
                formik.touched.file = false
                setLoading(false)
            } catch (error) {
                setLoading(false);
                console.error(error.message);
                alert(error.message);
            }
        }
    })
    const historial=()=>{
        let query = Buffer.from(
            JSON.stringify({"idCaso": llaves && llaves["idCaso"],
            "idImplicado": 999,
           })
          ).toString('base64')
          dispatch(obtenerGrillaHistorialGastos(query))

    }

    const validateMontoMoneda = (value, action) => {
        let monto = 0;
    
        if (action === 'format') monto = formatoMonto(value);
        else {
          if (Number(formik.values.moneda) === 30001) monto = resetFormatoMontoSinPunto(value);
          else monto = resetFormatoMonto(value);
        }
    
        return monto;
      }
    return (
        <>
        <LoadingComponent show={loading}/>
            <Modal show={showGastos}
                onHide={handleCloseGastos}
                size='xl'>
                <Form onSubmit={
                    formik.handleSubmit
                }>
                    <GastosHonorarios formik={formik}
                        setMiMontoNOFormato={setMiMontoNOFormato}
                        showToastAnular={showToastAnular}
                        setShowToastAnular={setShowToastAnular}
                        showToast={showToast}
                        setShowToast={setShowToast}
                        isLimpiar={isLimpiar}
                        setIsLimpiar={setIsLimpiar}
                        listaGrilla={listaGrilla}
                        setIsGastoHonorario={setIsGastoHonorario}
                        limites={limites}
                        onFileChange={handleFileChange}
                        />
                    <Acciones
                        handleShowToastAnular={handleShowToastAnular}
                        setIsLimpiar={setIsLimpiar}
                        handleCloseGastos={handleCloseGastos}
                        setListaGrilla={setListaGrilla}
                        listaGrilla={listaGrilla}
                        submitLoading={loading}
                    />
                </Form>
            </Modal>

            <Modal show={showConfirmGrande} onHide={handleCancelArchivoGrande} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Confirmación
                    </Card.Header>
                    <Card.Body>
                        {`El archivo seleccionado supera los ${limites.liviano / 1000000}MB, por lo que la carga puede demorar más de lo habitual. ¿Desea continuar?`}
                    </Card.Body>
                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={handleCancelArchivoGrande}>No</Button>
                        <Button className='m-2 w-auto' variant='danger' onClick={handleConfirmArchivoGrande}>Sí</Button>
                    </Card.Footer>
                </Card>
            </Modal>
        </>
    )
}

export default GastosHonorariosModal
const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
    });
  };